<template>
  <div>
    <div v-if="loading" class="app-content-column">
      <Spinner />
    </div>

    <div v-if="!loading">
      <Subheader :title="engagement.title" />

      <div class="app-content-column">
        <div class="card-custom centered-block">
          <img :src="engagement.photo" :alt="engagement.title + ' photo'" />

          <div class="card-content-container">
            <h5>{{ engagement.title }}</h5>
            <p v-for="(p, index) in engagement.fullDescription.split('\n')" :key="index + p">
              {{ p }}
            </p>
          </div>

          <img v-for="p in engagement.secondaryPhotos" :key="p.id" :src="p.image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Engagement from '@/services/engagements'

import { errorMessage } from '@/services/utils/apiErrors'

import Subheader from '@/components/Subheader'
import Spinner from '@/components/Spinner'

export default {
  name: 'EngagementDetails',
  components: {
    Subheader,
    Spinner,
  },
  data() {
    return {
      engagement: Engagement.create(),
      loading: false,
    }
  },
  async created() {
    this.engagement.id = this.$route.params.engagementId
    await this.refreshData()
  },
  methods: {
    async refreshData() {
      this.loading = true

      try {
        const engagementResponse = await Engagement.api.retrieve(this.engagement.id)
        this.engagement = engagementResponse
      } catch {
        errorMessage()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/forms';
@import '../styles/mixins/buttons';

.card-custom {
  margin: 1.25rem;

  background-color: #ffffff;
  border-radius: 0.25rem;
  box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.08);
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    background-color: rgba($primary, 0.7);

    &:not(:last-of-type) {
      margin-bottom: 1rem;
    }
  }

  .card-content-container {
    padding: 1.5rem;
  }
}

.centered-block {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
</style>
